import React from 'react';
import { ShieldCheckIcon, ZapIcon, WalletIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { images, price } from '../data/salesCopy';
const trustItems = [{
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: WalletIcon,
  label: `Arrancás con menos de ${price.minKit}`
}];
export function Hero() {
  return <header className="bg-ink text-cream" data-id="element-44" data-mp="12a0l5b5wm0um">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 pb-12 pt-10 sm:px-6 sm:pb-16 sm:pt-14 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16 lg:py-24" data-id="element-45" data-mp="128pi5dka8x4k">
        <div data-id="element-46" data-mp="sai4b3laiv6s">
          <p className="text-[10px] font-medium uppercase tracking-overline text-champagne sm:text-[11px]" data-id="element-47" data-mp="sa9szg4tfxxp">
            Método Nail-Elite · Business-Art System
          </p>
          <h1 className="mt-4 font-display font-semibold leading-[1.12] sm:mt-6" data-id="element-48" data-mp="3d21rlvg2wgmo">
            <span className="block text-[1.95rem] sm:text-5xl lg:text-[3.4rem]" data-id="element-49" data-mp="382fgpsnq3ch1">
              ¿Querés empezar a tener tu propia plata?
            </span>
            <span className="mt-3 block text-[1.45rem] text-champagne-light sm:mt-4 sm:text-4xl lg:text-[2.4rem]" data-id="element-50" data-mp="3j925dog4jqvj">
              Este pack es para vos
            </span>
            <span className="mt-3 block text-lg font-normal italic text-cream/80 sm:mt-4 sm:text-2xl" data-id="element-51" data-mp="39b4ip5dwy251">
              Emprendé en solo 21 días.
            </span>
          </h1>
          <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-cream/75 sm:mt-7 sm:text-lg" data-id="element-52" data-mp="30i15my76jrax">
            Sin academia cara, sin años de experiencia y sin una inversión inicial mayor a{' '}
            {price.minKit}. Solo el método exacto que nadie más te está enseñando.
          </p>

          <div className="mt-7 sm:mt-10" data-id="element-53" data-mp="2viy2xkeo9x64">
            <CtaButton data-id="element-54" data-mp="2vjzmkd9r7rzg">Quiero empezar ahora</CtaButton>
          </div>

          <ul className="mt-6 grid gap-2.5 sm:mt-8 sm:flex sm:flex-wrap sm:gap-x-7 sm:gap-y-3" data-id="element-55" data-mp="2hina4btsy8ib">
            {trustItems.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-[13px] text-cream/70 sm:text-sm" data-id="element-56" data-mp="2lml8ulf7thau">
                <Icon aria-hidden="true" className="h-4 w-4 shrink-0 text-champagne" data-id="element-57" data-mp="nbbc4wdi0748" />
                {label}
              </li>)}
          </ul>
        </div>

        <div className="rounded-2xl border border-ink-line bg-ink-soft p-5 sm:p-7" data-id="element-58" data-mp="icrpetr2yrat">
          <p className="font-display text-2xl text-champagne-light sm:text-3xl" data-id="element-59" data-mp="de6n8os9pxjq">
            {price.setPrice}+ por set
          </p>
          <p className="mt-2 text-[14px] leading-snug text-cream/70 sm:text-sm" data-id="element-60" data-mp="1ayt9d7fj7xel">
            La tarifa que alcanzan las alumnas que aplican el método, trabajando desde casa y con su
            propia agenda.
          </p>
        </div>
      </div>
    </header>;
}